import { setAlert } from "./alert";
import config from "../../config";
const GET_EMAIL_SCHEDULE_LIST = "GET_EMAIL_SCHEDULE_LIST";
const GET_EMAIL_SCHEDULE_LIST_SUCCESS = "GET_EMAIL_SCHEDULE_LIST_SUCCESS";
const GET_EMAIL_SCHEDULE_LIST_FAILED = "GET_EMAIL_SCHEDULE_LIST_FAILED";
const DEL_EMAIL_SCHEDULE_CONTENT = "DEL_EMAIL_SCHEDULE_CONTENT";
const DEL_EMAIL_SCHEDULE_CONTENT_S = "DEL_EMAIL_SCHEDULE_CONTENT_S";
const DEL_EMAIL_SCHEDULE_CONTENT_F = "DEL_EMAIL_SCHEDULE_CONTENT_F";
const UPDATE_EMAIL_SCHEDULE = "UPDATE_EMAIL_SCHEDULE";
const UPDATE_EMAIL_SCHEDULE_CONTENT_S = "UPDATE_EMAIL_SCHEDULE_CONTENT_S";
const UPDATE_EMAIL_SCHEDULE_CONTENT_F = "UPDATE_EMAIL_SCHEDULE_CONTENT_F";
// const SET_SELECTED_DEAL = "SET_SELECTED_DEAL";
const initialState = {
  data: [], // for email schedules
  count: 0, // total number of items
  page: 1, // current page
  limit: 10, // page size
  isNextPage: false,
  loading: false,
  error: null
};
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_EMAIL_SCHEDULE_LIST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EMAIL_SCHEDULE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload.schedules,
        count: payload.count,
        page: payload.page,
        limit: payload.limit,
        isNextPage: payload.is_next_page
      };

    case GET_EMAIL_SCHEDULE_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: payload || "Failed to fetch email schedules"
      };

    default:
      return state;
  }
}
export function getEmailSchedules(page, limit, search = "") {
  return (dispatch) =>
    dispatch({
      types: [
        GET_EMAIL_SCHEDULE_LIST,
        GET_EMAIL_SCHEDULE_LIST_SUCCESS,
        GET_EMAIL_SCHEDULE_LIST_FAILED
      ],
      promise: (fetch) =>
        fetch.get("api/EmailSchedules", {
          params: {
            page,
            limit,
            search
          }
        })
    }).then((res) => {
      if (res.status === 1) {
        dispatch(setAlert(`Email schedules fetched successfully`, "success"));
      } else if (res.status === 0) {
        dispatch(setAlert(`Email schedules fetched successfully`, "error"));

        return Promise.reject();
      }

      return res;
    });
}

export function deleteEmailSchedule(id) {
  return (dispatch) =>
    dispatch({
      types: [
        DEL_EMAIL_SCHEDULE_CONTENT,
        DEL_EMAIL_SCHEDULE_CONTENT_S,
        DEL_EMAIL_SCHEDULE_CONTENT_F
      ],
      promise: (fetch) => fetch.delete(`api/EmailSchedules/${id}`)
    })
      .then((res) => {
        if (res.status === 1) {
          dispatch(setAlert(`Schedule deleted successfully`, "success"));
        } else {
          dispatch(setAlert(res.message || `Error deleting schedule`, "error"));
          return Promise.reject(res);
        }

        return res;
      })
      .catch(() => {
        dispatch(setAlert(`Error deleting schedule`, "error"));
        return Promise.reject();
      });
}
export function updateEmailSchedule(id, data) {
  return (dispatch) =>
    dispatch({
      types: [
        UPDATE_EMAIL_SCHEDULE,
        UPDATE_EMAIL_SCHEDULE_CONTENT_S,
        UPDATE_EMAIL_SCHEDULE_CONTENT_F
      ],
      promise: (fetch) => fetch.put(`api/EmailSchedules/${id}`, { data })
    })
      .then((res) => {
        if (res.status === 1) {
          dispatch(setAlert(`Schedule updated successfully`, "success"));
        } else {
          dispatch(setAlert(res.message || `Error updating schedule`, "error"));
          return Promise.reject(res);
        }

        return res;
      })
      .catch(() => {
        dispatch(setAlert(`Error updating schedule`, "error"));
        return Promise.reject();
      });
}
